<script>
  import { goto } from '@sapper/app';

  import { productDataStore } from '../../stores/ProductData.js';
  import { isTablet, isMobile } from '../../stores/Designer.js';
  import { designerProductOverride } from '../../stores/DesignerProductOverride.js';

  // export let productSlug;
  export let designSteps;
  export let segment;
  export let currentStep = 0;
  export let showFloatingProgress;

  $: if (!$isMobile && !$isTablet) {
    showFloatingProgress = false;
  }

  let slug;
  if ($productDataStore.top) {
    slug = $productDataStore.top.slug;
  } else {
    slug = $productDataStore[$productDataStore.showing].slug;
  }

  function toggleFloatingProgress() {
    if (showFloatingProgress) {
      showFloatingProgress = false;
    } else {
      showFloatingProgress = true;
    }
  }

  function handleViewAllProducts() {
    $designerProductOverride = true;
    const categorySlug = $productDataStore?.categorySlug ? $productDataStore.categorySlug : $productDataStore.category;
    const collectionSlug = $productDataStore?.collectionSlug
      ? $productDataStore.collectionSlug
      : $productDataStore.collection;
    goto(`/products/${categorySlug}/${collectionSlug}`);
  }
</script>

<nav>
  <div class="left">
    <a href="/">
      <img src="https://images.uniformhero.com.au/assets/logo.jpg" class="logo" alt="" />
    </a>
    <div class="change-product">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <span on:click={handleViewAllProducts}>View All Products</span>
    </div>
  </div>

  <div class="desktop-steps">
    <div class="steps">
      {#each designSteps as step, idx}
        <span class="step" class:active={segment === step.segment} class:current={segment === step.segment}>
          <a href={'/design/' + slug + '/' + step.segment} sapper:noscroll>
            <span class="number">{idx + 1}</span>
            <span class="label">{step.label}</span>
          </a>
        </span>
      {/each}
    </div>
  </div>
  <div class="mobile-steps">
    <div class="steps">
      <div class="step" class:active={true} class:current={true}>
        <span class="number">{currentStep.stepNumber}</span>
        <span class="label">{currentStep.label}</span>
      </div>
    </div>
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="pricing" on:click={toggleFloatingProgress}>
    <span>Save/Share</span>
    <img src="img/icons/triangle.svg" alt="" />
  </div>
</nav>

<style>
  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 7rem;
    position: relative;
  }

  nav:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 5px;
    background-color: #fe5900;
  }

  a {
    text-decoration: inherit;
    color: inherit;
  }

  .left {
    display: flex;
    align-items: center;
  }

  .left img {
    max-width: 150px;
  }

  .logo {
    height: 5rem;
  }

  .steps {
    display: flex;
    background-color: #f3f2f2;
  }

  .step .number {
    width: 3rem;
    height: 3rem;
    border-radius: 0.8rem;
    display: inline-flex;
    background-color: #fff;
    color: #888;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  }

  .step {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 1.2rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: #555;
    text-decoration: none;
    height: 7rem;
  }

  .step.active {
    background-color: #fff;
    position: relative;
    color: #000;
  }

  .step.active .number {
    background-color: #fe5900;
    color: #fff;
  }

  .change-product {
    display: none;
    font-weight: 600;
    font-size: 1.6rem;
    text-align: center;
    color: #616166;
    border-right: 1px solid #fe5900;
    padding-right: 2rem;
  }

  .change-product span {
    cursor: pointer;
  }

  .mobile-steps,
  .desktop-steps {
    background-color: #f3f2f2;
  }

  .mobile-steps {
    display: block;
  }

  .desktop-steps {
    display: none;
  }

  .pricing {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    padding: 1rem 1.5rem;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 10rem;
    color: #fe5900;
    font-family: 'Oswald', sans-serif;
  }

  @media screen and (min-width: 450px) {
    .change-product {
      display: block;
    }
  }

  @media screen and (min-width: 1000px) {
    .step {
      padding: 1.5rem 2rem 1.5rem 1.5rem;
    }

    .pricing {
      display: none;
    }

    .mobile-steps {
      display: none;
    }

    .desktop-steps {
      display: block;
    }
  }

  @media screen and (min-width: 1450px) {
    .step.active:after {
      left: 100%;
      top: 0;
      border: solid transparent;
      content: '';
      position: absolute;
      pointer-events: none;
      border-color: transparent;
      border-left-color: #fff;
      border-width: 30px;
      /* margin-top: -25px; */
    }

    .steps {
      padding-right: 3rem;
    }

    .step.current {
      margin-right: 3rem;
    }
  }
</style>
